import { cssModule, isNumber, mergeClasses, useAutoFocus, useMergedRefs } from "../../shared";
export function useLink({
  active,
  autoFocus,
  cssModule: module,
  disabled,
  external,
  focus,
  forwardedRef,
  hover,
  rel,
  shape,
  target,
  underline,
  variant,
  visited
}) {
  const linkRef = useMergedRefs(forwardedRef);
  useAutoFocus(linkRef, {
    delay: isNumber(autoFocus) ? autoFocus : undefined,
    isDisabled: !autoFocus
  });
  return {
    linkProps: {
      className: mergeClasses(module, cssModule("o-ui-link", variant, underline === "none" ? "no-underline" : underline, shape, active && "active", focus && "focus", hover && "hover", visited && "visited", disabled && "disabled")),
      ref: linkRef,
      rel: rel !== null && rel !== void 0 ? rel : external ? "noopener noreferrer" : undefined,
      tabIndex: disabled ? -1 : undefined,
      target: target !== null && target !== void 0 ? target : external ? "_blank" : undefined
    },
    showNewTabIndicator: target === "_blank"
  };
}